module.exports = __webpack_public_path__ + "img/NP.c2724435.svg";